
<!--<div class="col-lg-12" style="margin-top: 100px;">
  <div class="loading-div" *ngIf="isLoading">
    <div class="loading-bar">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p class="mt-3">Processing data. Please wait..</p>
    </div>
  </div>
  <div class="col-lg-8 text-center" >
                 <h4>Enter a new password</h4>
                 </div>
                    <fieldset style="border:1px solid #ced4da" class="col-lg-4 offset-lg-3 ">
                        <form>
                          <label for="pwd"  >New Password</label>
                          <div class="form-group">
                             
                                <input type="password" class="form-control"  id="pwd" style="text-indent:20px;">                          
                             </div>
                             <label for="cnfrmPassword2" >Confirm Password</label>  
                             <div class="form-group">
                    
                                <input type="password" class="form-control" id="cnfrmPassword2" style="text-indent:20px;">
                              </div>
                        <input style="height: 42px;line-height: 7px;background-color:#007bff;border:#007bff;
                        " class="btn btn-lg btn-primary btn-block" value="Change Password" type="submit" (click)="submitnewpassword()">
                <button class="btn btn-secondary float-right" style="color:black"  data-dismiss="modal" aria-hidden="true">Cancel</button>
                </form>
                </fieldset>
           
            </div>-->
            <!DOCTYPE html>
            <html lang="en">
               <meta http-equiv="content-type" content="text/html;charset=utf-8" />
               <head>
                  <meta charset="utf-8" />
                  <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
                  <title>TANUVAS</title>
                  <meta content='width=device-width, initial-scale=1.0, shrink-to-fit=no' name='viewport' />
                  <!--  Social tags  -->
                  <meta name="keywords" content="">
                  <meta name="description" content="">
                  <!--     Fonts and icons     --> 
               </head>
               <body class="off-canvas-sidebar tanuvas">
                  <div class="wrapper wrapper-full-page">
                     <div class="page-header register-page header-filter" filter-color="black" style="background-image: url('assets/images/group_1293.png')">
                         <div class="container">
                           <div class="row">
                            <div class="loading-div" *ngIf="isLoading">
                              <div class="loading-bar">
                                  <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                  <p class="mt-3">Processing data. Please wait..</p>
                              </div>
                            </div>
                              <div class="col-md-5 ml-auto mr-auto">
                                 <div class="card card-signup">
                                    <h2 class="card-title text-center">Enter a new password</h2>
                                    <div class="card-body">
                                       <div class="row">
                                          <div class="col-md-12 mr-auto">
                                          
                                             <form class="form" (keydown)="keyDownFunctionchangepassword($event)" [formGroup]="registerForm">
                                                <div class="form-group has-default">
                                                   <div class="input-group">
                                                      <input type="password" id="pwd" formControlName="password" class="form-control" placeholder="New Password" >
                                                     </div>
                                                     <div class="selectvalidate" *ngIf="f.password.hasError('required') && f.password.touched">Password is required</div>
                                                     <div class="selectvalidate" *ngIf="f.password.hasError('minlength') && f.password.touched">Password must be at least 6 characters</div>                          
                                                 
                                                </div>
                                                <div class="form-group has-default">
                                                   <div class="input-group">
                                                      <input type="password" id="password" placeholder="ConfirmPassword" formControlName="confirmPassword" class="form-control">
                                    
                                                   </div>
                                                   <div class="selectvalidate" *ngIf="f.confirmPassword.hasError('required') && f.confirmPassword.touched">Confirm Password is required</div>
                                                   <div class="selectvalidate" *ngIf="f.confirmPassword.hasError('mustMatch') && f.confirmPassword.touched">Passwords must match</div>
                              
                                                </div>
                                                <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="margin-top: 22px;">
                                                  <button (click)="submitnewpassword()" type="submit" class="btn btn-fill btn-primary mb-3" >Submit<div class="ripple-container"></div></button>
                                                  <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
                                                  </div>
                                             </form>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                            </div>
                          </div>
                       </div>
                    </div>      
                 </body>
              </html>
              